import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Typography } from '@material-ui/core';
import { ru } from 'locale';
import bg from './bg.svg';
import useStyles from './NotFoundPage.styles';

const NotFoundPage = () => {
  const classes = useStyles();
  const history = useHistory();

  const handleClick = () => {
    history.push('/');
  };

  return (
    <div className={classes.container}>
      <Typography variant="h5" className={classes.title}>
        {ru.notFoundPage}
      </Typography>
      <img src={bg} alt={ru.notFoundPage} className={classes.img} />
      <div className={classes.buttonContainer}>
        <Button
          variant="outlined"
          color="primary"
          className={classes.backButton}
          onClick={handleClick}
        >
          {ru.backToHome}
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;
